/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I make grouped bars?`)
};

const es_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo hago barras agrupadas?`)
};

const de_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie erstelle ich gruppierte Balken?`)
};

const nl_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe maak ik gegroepeerde staven?`)
};

const fr_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment créer des barres groupées ?`)
};

const it_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come faccio barre raggruppate?`)
};

const pt_br2_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço barras agrupadas?`)
};

const pt_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço barras agrupadas?`)
};

const ja_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ化棒グラフを作るには？`)
};

const zh_bar_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何制作分组柱状图？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_q2", locale)
	if (locale === "en") return en_bar_faq_q2(inputs)
	if (locale === "es") return es_bar_faq_q2(inputs)
	if (locale === "de") return de_bar_faq_q2(inputs)
	if (locale === "nl") return nl_bar_faq_q2(inputs)
	if (locale === "fr") return fr_bar_faq_q2(inputs)
	if (locale === "it") return it_bar_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_q2(inputs)
	if (locale === "pt") return pt_bar_faq_q2(inputs)
	if (locale === "ja") return ja_bar_faq_q2(inputs)
	return zh_bar_faq_q2(inputs)
};